/** @type {import('./$types').LayoutLoad} */
export const load = ({ data }) => {
    return {
        ...data,
        'layout': Date.now()
    };
};